/**
 *
 *
 * @author edmsamuel
 */
import React from 'react'
import { Table, Divider, Input, InputNumber, Icon, Button, message } from 'antd'
import View from '../../components/View'
import Cell from '../../components/Cell'
import Crud from '../../components/Crud'
import Api from '../../Api'
import Exception from '../../Exception'
import numeral from 'numeral'
import Adjuntos from './Components/CotizacionAdjuntos'
import Info from './Components/CotizacionInfo'
import Adicionales from './Components/CotizacionAdicionales'
import Tecnica from './Components/CotizacionTecnica'

class Cotizacion extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      busqueda: '',
      loading: false,
      cotizacionPendiente: false,
      has_srv: false,
      data: [],
      old: [],
    }

    this.info = React.createRef()
    this.tecnicas = React.createRef()
    this.adicionales = React.createRef()
    this.adjuntos = React.createRef()

    this.columns = Cell.buildList([
      /**
       * Pda
       *
       */
      { title: '#', dataIndex: 'dPrecio', width: 40,
        render: (_, _2, idx) => <small>#{numeral(idx + 1).format('0,0')}</small>
      },
      /**
       * Categoría
       */
      { title: 'CATEGORÍA', dataIndex: 'insumo.subFamilia.familia.nombre', width: 120, render: (_, record) => (
        <div style={styles.cellContainer}>
          {record.servicio ? (
            <div>
              <p>{  record.servicio.requisicion.clasificacionServicio.nombre}</p>
            </div>
          ) : (
            <div>
              <label>FAMILIA</label>
              <p>{record.insumo.subFamilia.familia.nombre}</p>
            </div>
          )}

          {record.servicio ? null : (
            <div>
              <label>SUB FAMILIA</label>
              <p>{record.insumo.subFamilia.nombre}</p>
            </div>
          )}
        </div>
      )},

      /**
       * Insumo
       */
      { title: 'INSUMO', dataIndex: 'insumo.descripcion', width: 300, render: (val, record) => (
        <div style={styles.cellContainer}>
          <label>CÓDIGO</label>
          <p style={{ marginBottom: 12 }}>{record.servicio ? (record.servicio.codigo || record.servicio.referencia) : record.insumo.codigo}</p>

          <label>{record.servicio ? record.servicio.medida.nombre : record.insumo.medida.nombre}</label>
          <p style={{ marginBottom: 12 }}>{record.servicio ? record.servicio.descripcion : record.insumo.descripcion}</p>

          <label>ESPECIFICACIONES</label>
          {this.state.cotizacionPendiente ? (
            <Input.TextArea
              size='small'
              value={record.sEspecificaciones}
              onChange={e => this.setState({
                data: this.state.data.map(
                  item => item.iId !== record.iId ? item : ({ ...item,
                    sEspecificaciones: e.target.value.toUpperCase(),
                    changed: true,
                  })
                )
              })}
              defaultValue={record.sEspecificaciones}
            />
          ) : (
            <p>{record.sEspecificaciones}</p>
          )}
        </div>
      )},

      /**
       * Volumen
       */
      { title: 'COTIZACIÓN', dataIndex: 'dCantidad', width: '9%', render: (_, record) => (
        <div style={styles.cellContainer}>
          {record.servicio || ['PZA', 'PIEZA'].indexOf(record.insumo.medida.nombre) > -1 ? null : (
            <div style={{ marginBottom: 12 }}>
              <label>PIEZAS</label>
              <span>{numeral(record.dPiezas).format('0,0')}</span>
            </div>
          )}

          <label>CANTIDAD</label>
          <span style={{ marginBottom: 12 }}>
            {numeral(record.dCantidad).format('0,0.00')} {record.servicio ? record.servicio.medida.nombre : record.insumo.medida.nombre}
          </span>

          <label>P.U.</label>
          {this.state.cotizacionPendiente ? (
            <InputNumber
              size='small'
              value={record.dPrecio ? record.dPrecio.toString() : '0'}
              precision={4}
              onChange={val => this.setState({
                data: this.state.data.map(
                  item => item.iId !== record.iId ? item : ({ ...item,
                    dPrecio: val > 0 ? val : 0,
                    changed: true,
                  })
                )
              })}
            />
          ) : (
            <p>{numeral(record.dPrecio).format('$0,0.0000')}</p>
          )}
        </div>
      )},

      /**
       * Importe
       */
      { key: 'importe', width: 100, title: 'IMPORTE', dataIndex: 'dPrecio', render: (_, { dCantidad, dPrecio }) => (
        <div style={{ paddingLeft: 10 }}>
          {numeral(dCantidad * dPrecio).format('$0,0.00')}
        </div>
      )},

      /**
       * Acciones
       */
      { key: 'acciones', dataIndex: 'dPrecio', width: 100,
        title: (<Icon type='block' style={{ fontSize: 20 }} />),
        render: (_, record) => (
          <div>
            {!record.changed ? null : (
              <Button icon='save' shape='circle-outline'
                onClick={() => {
                  const promise = this.save(record.iId)
                  if (promise) {
                    promise.then(() => message.success('Guardado'))
                  }
                }}
              />
            )}

            {!record.changed ? null : (
              <Button icon='close' shape='circle-outline' onClick={() => this.cancel(record.iId)} />
            )}

            <Button icon='tag' shape='circle-outline' onClick={() => this.adicionales.current.load(this.props.match.params.id, record.iId)} />
          </div>
      )}
    ])
  }


  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    this.load(this.props.match.params.id)
  }

  /**
   * Cargar
   */
  load = async (cotizacionId) => {
    try {
      this.setState({ loading: true })

      const { data: cuadro } = await Api.query({
        __returnType: 'one',
        model: 'ComCuadroComparativo',
        attributes: [
          ['iIdRequisicion', 'requisicionId'],
          ['sRequisicion', 'folios'],
        ],
        include: [{
          as: 'requisicion',
          required: false,
          attributes: [['iId_TipoRequisicion', 'tipoId']],
        }],
        where: {
          iId: cotizacionId,
          iActivo: true
        },
      })

      if (!cuadro) {
        throw new Error('Cotización no encontrada')
      }

      const includeInsumo = {
        as: 'insumo',
        attributes: [
          ['sIdInsumo', 'codigo'],
          ['mDescripcion', 'descripcion']
        ],
        include: [
          { as: 'medida', attributes: [['sNombre', 'nombre']] },
          {
              as: 'subFamilia',
              attributes: [['sDescripcion', 'nombre']],
              include: [{ as: 'familia', attributes: [['sDescripcion', 'nombre']] }]
          }
        ],
        where: {
          iActivo: true,
          '$ComCuadroComparativoPrecio.iIdTipo$': { $ne: 3 },
        }
      }

      const includeServicio = {
        as: 'servicio',
        attributes: [
          ['sReferencia', 'referencia'],
          ['sCmrCodigo', 'codigo'],
          ['sDescripcion', 'descripcion'],
        ],

        include: [
          { as: 'medida', attributes: [['sNombre', 'nombre']] },
          { as: 'requisicion', attributes: ['iId'],
            include: [{ as: 'clasificacionServicio', attributes: [['sClasificacion', 'nombre']] }]
          }
        ],
        where: {
          iActivo: true,
          '$ComCuadroComparativoPrecio.iIdTipo$': 3,
        }
      }

      const response = await Api.query.list({
        items: {
          model: 'ComCuadroComparativoPrecio',
          attributes: [
              'iId',
              'sEspecificaciones',
              'sComentarios',
              'dPiezas',
              'dCantidad',
              'dPrecio',
              'iSeleccionado'
          ],
          include: [
            includeInsumo,
            includeServicio,

            {
              as: 'adicionales',
              attributes: [
                ['iIdTipo', 'tipo'],
                ['iIdSobreCosto', 'sobreCosto'],
                ['iIdImpuesto', 'impuesto'],
                ['dPrecio', 'precio'],
              ],
              required: false,
              where: { iActivo: true }
            }
          ],
          where: {
            iIdCuadro: cotizacionId,
            iIdProveedor: Api.getProviderId(),
            iActivo: true
          }
        },

        firmas: {
          model: 'ComCuadroComparativoFirma',
          attributes: ['iId'],
          where: {
            iIdCuadro: cotizacionId,
            iIdUsuario: { $gt: 0 },
            iActivo: true,
          },
          limit: 1,
        },
      })

      this.setState({
        data: response.data.items,
        old: response.data.items,
        cotizacionPendiente: response.data.firmas.length === 0,
        loading: false,
        has_srv: response.data.items.some(pu => pu.servicio)
      })
    } catch (error) {
      this.setState({
        data: [],
        cotizacionPendiente: false,
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Reload
   *
   */
  reload = () =>
    this.load(this.props.match.params.id)

  /**
   * Save
   *
   */
  save = (itemId) => {
    const data = this.state.data.find(record => record.iId === itemId)

    if (data) {
      const old = this.state.old.find(record => record.iId === data.iId)
      const keys = Object.keys(old).filter(key => key !== 'changed')
      const changes = {}
      for (const key of keys) {
        if (old[key] !== data[key]) {
          changes[key] = data[key]
        }
      }

      if (Object.keys(changes).length) {
        this.setState({ loading: true })
        return Api.put(`/com/cotizaciones/precios/${data.iId}`, changes)
          .then(() =>
            this.setState({
              loading: false,
              data: this.state.data.map(record =>
                record.iId !== data.iId ? record : ({ ...record, changed: false })
              ),
              old: this.state.old.map(record =>
                record.iId !== data.iId ? record : ({ ...data, changed: false })
              ),
            })
          )
          .catch(error => {
            this.setState({ loading: false })
            Exception.load(error).show()
          })
      }
    }
  }

  /**
   * cancel
   */
  cancel = (recordId) => {
    this.setState({
      data: this.state.data.map(item =>
        item.iId !== recordId ? item : this.state.old.find(old => old.iId === recordId)
      )
    })
  }

  /**
   * saveAll
   */
  saveAll = () => {
    Promise.all(
      this.state.data
        .filter(item => item.changed === true)
        .map(item => this.save(item.iId))
        .filter(item => item instanceof Promise)
    )
    .then(() =>
      message.success('Terminado')
    )
    .catch(error =>
      Exception.load(error).show()
    )
  }

  /**
   * cancelAll
   */
  cancelAll = () => {
    this.setState({
      data: this.state.data.map(item =>
        !item.changed ? item : this.state.old.find(old => old.iId === item.iId)
      )
    })
  }

  /**
   * Render
   *
   */
  render() {
    const crud = (
      <Crud
        collection={this.props.Collection}
        buttons={['reload']}
        onReload={this.reload}
        children={[
          <Button
            key='attachments'
            icon='paper-clip'
            onClick={() => this.adjuntos.current.load(this.props.match.params.id)}
          />,
          <Button
            key='info'
            icon='info'
            onClick={() => {
              this.info.current.refs.wrappedComponent.load(this.props.match.params.id)
            }}
          />,
          // <Button
          //   key='techQuotation'
          //   icon='build'
          //   onClick={() => this.tecnicas.current.load(this.props.match.params.id)}
          // />
        ].concat(
          this.state.data.filter(item => item.changed === true).length ? [
            <Button
              key='saveAll'
              icon='save'
              onClick={this.saveAll}
            />,
            <Button
              key='cancelAll'
              icon='close'
              onClick={this.cancelAll}
            />
          ] : []
        )}
      />
    )

    const tableTitle = (
      <div>
        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.setState({ busqueda: value || '' })
          }
          allowClear
        />
        <Divider type='vertical' />
        {crud}
      </div>
    )

    const tableData = !this.state.busqueda.length ?
      this.state.data :
      this.state.data.filter(
        item => item.insumo.descripcion.toUpperCase().indexOf(this.state.busqueda.trim().toUpperCase()) > -1
    )

    return (
      <View>
        <Info ref={this.info} />
        <Adjuntos ref={this.adjuntos} />
        <Adicionales ref={this.adicionales} />
        <Tecnica ref={this.tecnicas} />

        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1>Cotización #{numeral(this.props.match.params.id).format('#00000')}</h1>
          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={tableData}
            columns={!this.state.has_srv ? this.columns : this.columns.filter((_, idx) => idx !== 1)}
            loading={this.state.loading}
            pagination={{ pageSize: 50 }}
            title={() => tableTitle}
          />
        </div>
      </View>
    )
  }
}

const styles = {
  cellContainer: {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
  }
}

export default Cotizacion
